import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AlertTimelineItem from "./AlertTimelineItem";
import AlertCommentForm from "../AlertCommentForm";
import AlertTimelineItemWithoutLine from "./AlertTimelineItemWithoutLine";
import * as itemType from "./alertTimelineItemTypes";

const AlertTimeline = props => (
  <React.Fragment>
    <AlertCommentForm
      alertId={props.alertId}
      onAlertCommentCreated={props.onAlertCommentCreated}
    />
    <div className="fable:mb-8" />
    {props.items.map(item => (
      <AlertTimelineItem key={item.date}>
        {item.type === itemType.WORKFLOW_EVENT ? (
          <WorkflowEventMessage item={item} />
        ) : item.type === itemType.COMMENT ? (
          <CommentMessage item={item} />
        ) : item.type === itemType.WORK_ORDER_EVENT ? (
          <WorkOrderEventMessage item={item} />
        ) : null}
      </AlertTimelineItem>
    ))}
    <AlertTimelineItemWithoutLine
      isWithoutLine={props.items.length === 0 ? true : false}
    >
      Alert raised on {formatDate(props.alert.opened)}
    </AlertTimelineItemWithoutLine>
  </React.Fragment>
);

const WorkflowEventMessage = props => (
  <React.Fragment>
    <span className="fable:font-bold">{props.item.user.name} </span>
    {props.item.action}{" "}
    <span className="fable:font-bold">
      {props.item.alertStatus != null ? props.item.alertStatus.description : ""}
    </span>{" "}
    on {formatDate(props.item.date)}
  </React.Fragment>
);

const WorkOrderEventMessage = props => (
  <React.Fragment>
    <span className="fable:font-bold">{props.item.user.name} </span>
    {props.item.action} added work order{" "}
    <span className="fable:font-bold">
      {props.item.workOrderNumber != null ? props.item.workOrderNumber : ""}
    </span>{" "}
    on {formatDate(props.item.date)}
  </React.Fragment>
);

const CommentMessage = props => (
  <div>
    <div className="fable:p-2 fable:border-l fable:border-r fable:border-t fable:bg-gray-50">
      <span className="fable:font-bold">{props.item.user.name}</span>{" "}
      commented on {formatDate(props.item.date)}
    </div>
    <div className="fable:p-2 fable:border cb-u-with-line-breaks">
      {props.item.description}
    </div>
  </div>
);

function formatDate(date) {
  return moment(date).format("D MMM YY, HH:mm");
}

AlertTimeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      user: PropTypes.shape({
        name: PropTypes.string
      }),
      description: PropTypes.string,
      alertStatus: PropTypes.shape({
        description: PropTypes.string
      })
    })
  ),
  alert: PropTypes.shape({
    opened: PropTypes.string
  }),
  alertId: PropTypes.string,
  onAlertCommentCreated: PropTypes.func
};

export default AlertTimeline;
